import { AvailableForBooking, Competence, OfferedService, SlotType } from "utils/interfaces"
import { getPublicServices } from "utils/helpers/psychologistUtil"

export function getDefaultAvailability(services: OfferedService[]) {
    const publicServices = getPublicServices(services)
    const online = publicServices.some((s) => s.online)
    const inPerson = publicServices.some((s) => !s.online)
    return typeOfAvailability({ online, in_person: inPerson, free: false, any: false })
}

export function typeOfAvailability(
    { online, in_person }: Record<SlotType, boolean>,
    defaultValue?: string
): string | undefined
export function typeOfAvailability(
    { online, in_person }: AvailableForBooking,
    defaultValue?: string
): string | undefined

export function typeOfAvailability(
    { online, in_person }: AvailableForBooking | Record<SlotType, boolean>,
    defaultValue?: string
): string | undefined {
    if (online && in_person) return "Лично и онлайн"
    else if (online && !in_person) return "Принимает онлайн"
    else if (!online && in_person) return "Принимает лично"
    return defaultValue
}

export function getPrices(services: OfferedService[]) {
    return getPublicServices(services).map(({ price }: OfferedService) => price)
}

export function getCommonCompetence(competencePsy: Competence[], reportedProblems: number[]) {
    let commonCompetence = 0
    competencePsy.forEach((i) => reportedProblems.includes(i.id) && commonCompetence++)
    return commonCompetence
}
